module.exports = __webpack_public_path__ + "img/delete-blue.4e3b8674.svg";